export default __webpack_public_path__ + "static/char-s-36-ja-2829b98fda5402573d86ee8246060a26.png";